import React, { useEffect, useState } from 'react';
import './Documents.css';
import api, { userService } from '../services/api';

const monthNames = ['Január','Február','Marec','Apríl','Máj','Jún','Júl','August','September','Október','November','December'];

const WorkReportUsers = ({ user }) => {
  const [users, setUsers] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [year] = useState(new Date().getFullYear());
  const [overview, setOverview] = useState(null); // { userId, year, month, weeks }
  const [loadingOverview, setLoadingOverview] = useState(false);
  const [overviewError, setOverviewError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        let list = [];
        if (user.role === 'admin') {
          const all = await userService.getAll();
          list = all.filter(u => !u.blocked);
        } else if (user.role === 'supervisor' && user.project_id) {
          const all = await userService.getAll();
          list = all.filter(u => u.project_id === user.project_id && !u.blocked);
        } else {
          list = [user];
        }
        const sorted = [...list].sort((a,b)=>{
          const an = (a.full_name || a.username || '').toLowerCase();
          const bn = (b.full_name || b.username || '').toLowerCase();
          return an.localeCompare(bn, 'sk');
        });
        setUsers(sorted);
      } catch (e) {
        // ignore for now
      }
    })();
  }, [user]);

  const toggle = (id) => setExpanded(prev => ({ ...prev, [id]: !prev[id] }));

  const downloadUrl = (uid, y, m) => `/api/work-report/${uid}/pdf?year=${y}&month=${String(m).padStart(2,'0')}`;

  const loadOverview = async (uid, y, m) => {
    try {
      setLoadingOverview(true);
      setOverviewError(null);
      const { data } = await api.get(`/work-report/${uid}`, {
        params: { year: y, month: String(m).padStart(2,'0') }
      });
      setOverview({ userId: uid, year: data.year, month: data.month, weeks: data.weeks || [] });
    } catch (e) {
      setOverview(null);
      setOverviewError('Nepodarilo sa načítať prehľad');
    } finally {
      setLoadingOverview(false);
    }
  };

  return (
    <div className="documents-container">
      
      <div className="documents-header">
        <h1 className="documents-title">🧾 Pracovný výkaz</h1>
        <div style={{marginLeft:'auto'}}>
          <input
            className="wr-search"
            type="text"
            placeholder="Hľadať používateľa..."
            onChange={(e)=>setUsers(prev=>prev.map(x=>x)) /* placeholder */}
            style={{padding:'6px 8px', border:'1px solid #dee2e6', borderRadius:'4px'}}
          />
        </div>
      </div>
                  

      <div className="users-list">
        {users.map(u => (
          <div key={u.id} className={`user-card ${u.blocked ? 'blocked' : ''}`}>
            <div className="user-header" onClick={() => toggle(u.id)}>
              <span className="caret">{expanded[u.id] ? '▼' : '▶'}</span>
              <span className="user-name" style={{ color: u.blocked ? '#dc3545' : undefined }}>{u.full_name || u.username}</span>
            </div>
            {expanded[u.id] && (
              <div className="documents-panel">
                <table className="documents-table">
                  <thead>
                    <tr>
                      <th>Mesiac</th>
                      <th style={{textAlign:'right'}}>Akcie</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.from({length:12}, (_,i)=>i+1).map(m => (
                      <tr key={m}>
                        <td>
                          <button
                            onClick={()=>loadOverview(u.id, year, m)}
                            title={`Zobraziť prehľad: ${monthNames[m-1]} ${year}`}
                            style={{background:'none', border:'none', padding:0, margin:0, color:'#0d6efd', cursor:'pointer', textDecoration:'underline'}}
                          >
                            {monthNames[m-1]} {year}
                          </button>
                        </td>
                        <td style={{textAlign:'right', display:'flex', gap:'10px', justifyContent:'flex-end'}}>
                          <button
                            onClick={()=>loadOverview(u.id, year, m)}
                            className="download-btn"
                            title={`Zobraziť prehľad: ${monthNames[m-1]} ${year}`}
                            style={{display:'inline-flex',alignItems:'center',gap:'6px', background:'none', border:'1px solid #dee2e6', borderRadius:'4px', cursor:'pointer', padding:'4px 8px', color:'#0d6efd'}}
                          >
                            <span aria-hidden>👁️</span>
                            <span>Prehľad</span>
                          </button>
                          <a
                            href={downloadUrl(u.id, year, m)}
                            className="download-btn"
                            title={`Stiahnuť PDF: ${monthNames[m-1]} ${year}`}
                            style={{display:'inline-flex',alignItems:'center',gap:'6px', background:'none', border:'none', cursor:'pointer', padding:0, color:'#0d6efd', textDecoration:'none'}}
                            target="_blank" rel="noreferrer"
                          >
                            <span aria-hidden>⬇️</span>
                            <span>Stiahnuť</span>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {overview && (
                  <div style={{marginTop:'20px'}}>
                    <h2 style={{margin:'12px 0'}}>Mesiac: {monthNames[(overview.month||1)-1]} {overview.year}</h2>
                    {loadingOverview && <div>Načítavam prehľad...</div>}
                    {overviewError && <div style={{color:'#dc3545'}}>{overviewError}</div>}
                    {!loadingOverview && !overviewError && (
                      <table className="documents-table">
                        <thead>
                          <tr>
                            <th>Týždeň</th>
                            <th>Dátum od</th>
                            <th>Dátum do</th>
                            <th>Práca</th>
                            <th style={{textAlign:'right'}}>Hodiny</th>
                            <th style={{textAlign:'right'}}>Sadzba</th>
                            <th style={{textAlign:'right'}}>Suma</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(overview.weeks || []).map((w, idx) => (
                            <tr key={idx}>
                              <td>{`KW${w.week}`}</td>
                              <td>{w.start}</td>
                              <td>{w.end}</td>
                              <td>{(w.tasks && w.tasks.length) ? w.tasks.join(', ') : '—'}</td>
                              <td style={{textAlign:'right'}}>{Number(w.hours || 0)}</td>
                              <td style={{textAlign:'right'}}>{w.hours ? `${(Number(w.amount||0)/Number(w.hours||1)).toFixed(2)} €` : '—'}</td>
                              <td style={{textAlign:'right'}}>{`${Number(w.amount || 0).toFixed(0)} €`}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}

              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkReportUsers;
